import React from 'react';
import styles from './RoundedLegendTwoMetricChartCard.module.scss';

interface Legend {
  color: string;
  text: string;
}

interface RoundedLegendTwoMetricChartCardProps {
  title: string;
  subtitle?: string;
  legend1: Legend;
  legend2: Legend;
  chartComponent?: React.ReactNode;
  backgroundColor: string;
  textColor: string;
}

const RoundedLegendTwoMetricChartCard: React.FC<
  RoundedLegendTwoMetricChartCardProps
> = ({
  title,
  subtitle,
  legend1,
  legend2,
  chartComponent,
  backgroundColor,
  textColor,
}) => {
  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <span className={styles.title} style={{ color: textColor }}>
            {title}
          </span>
          <span className={styles.subtitle} style={{ color: textColor }}>
            {subtitle}
          </span>
        </div>
        <div className={styles.legendContainer}>
          <div className={styles.legend}>
            <span
              className={styles.circle}
              style={{ backgroundColor: legend1.color }}
            />
            <span className={styles.legendText} style={{ color: textColor }}>
              {legend1.text}
            </span>
          </div>
          <div className={styles.legend}>
            <span
              className={styles.circle}
              style={{ backgroundColor: legend2.color }}
            />
            <span className={styles.legendText} style={{ color: textColor }}>
              {legend2.text}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.chartContainer}>{chartComponent}</div>
    </div>
  );
};

export default RoundedLegendTwoMetricChartCard;
